import React from 'react'
import { connect } from 'react-redux'

import { setUrl } from './modules/reducer'

//import { BrowserRouter as Router } from 'react-router-dom'
import { HashRouter as Router } from 'react-router-dom'

import Loader from './components/Loader'

import App from './App'

import { Font } from '@react-pdf/renderer'

const AppWithRouter = ({ setUrl }) => {
  const pathname = window && window.location && window.location.pathname
  const origin = window && window.location && window.location.origin
  //const href = window && window.location && window.location.href
  //const search = window && window.location && window.location.search

  const url = `${origin}${pathname}` //href.replace(search, '')

  setUrl(url)

  Font.register(`${url}Poppins-Bold.ttf`, { family: 'PoppinsBold' })

  Font.register(`${url}Poppins-Regular.ttf`, { family: 'Poppins' })
  //basename={pathname}
  return (
    <Router>
      <Loader url={url} />
      <App />
    </Router>
  )
}

/*
const mapStateToProps = ({ reducer }, ownProps) => {
  return {
    loaded: reducer.loaded,
    token: reducer.token,
    generatePdf: reducer.generatePdf,
    pdfLoading: reducer.pdfLoading,
    heightHeader: reducer.heightHeader
  }
}
*/

const mapDispatchToProps = { setUrl }

export default connect(
  null,
  mapDispatchToProps
)(AppWithRouter)
